/**
 * Documentation
 *
 *
 * <div data-br-progressbar data-br-optionname
 *  class="flex grow bg-gray-500">
 *     <div class="w-[1%] h-1 bg-green-500 text-center text-white"></div>
 * </div>
 */

import { addListener, removeListener } from "./support/utils";

class BRProgress
{
    static progressInstances = new Map();

    constructor(progressElement, options={})
    {
        if (progressElement && BRProgress.getInstance(progressElement) === undefined ) {

            this.brProgress = progressElement;
            const htmlOptions = {};
            const data = this.brProgress.dataset;

            if (this.brProgress.id === '') {
                const uuid = this.generateUUID();
                this.brProgress.setAttribute('id', uuid)
            }

            Object.keys(data).forEach(key => {
                if ( key.startsWith('br') ) {
                    const optionName = key.replace('br', '').toLowerCase();
                    htmlOptions[optionName] = data[key] === 'false' ? false : (data[key] === 'true' ? true : data[key]);
                }
            });

            // Default options
            const defaultOptions = {

            };

            const normalizedDefaultOptions = {};
            Object.keys(defaultOptions).forEach(key => {
                normalizedDefaultOptions[key.toLowerCase()] = defaultOptions[key];
            });

            this.options = {
                ...normalizedDefaultOptions,
                ...htmlOptions,
                ...options
            }

            this.brIndicator = this.brProgress.children[0];
            this.brPercentage = 0;

            this.incrementIndicator = this.incrementIndicator.bind(this);

            BRProgress.progressInstances.set(progressElement, this);
        }
    }

    generateUUID()
    {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    incrementIndicator(positionPercent)
    {
        this.brPercentage = positionPercent;

        this.brIndicator.style.width = positionPercent + "%";
        this.brIndicator.innerHTML = positionPercent + "%";
    }

    static initAll(parent)
    {
        if (!parent) parent = document;

        parent.querySelectorAll('[data-br-progressbar]').forEach(progressElement => {
            if (!BRProgress.progressInstances.has(progressElement)) {
                new BRProgress(progressElement);
            }
        });
    }

    static init(progressElement)
    {
        if (!BRProgress.progressInstances.has(progressElement)) {
            return new BRProgress(progressElement);
        }
        else {
            return BRProgress.progressInstances.get(progressElement);
        }
    }

    // Static method to access a widget instance from a DOM element
    static getInstance(progressElement) {
        return BRProgress.progressInstances.get(progressElement);
    }
}

export default BRProgress;